import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { update_user_details } from "../../../api/calls/user/update_user_details";
import { setContentModal, setMainModal } from "../../../reducers/slices/main";
import { update_details_thunk } from "../../../reducers/slices/user";
import { ProfileInput, PROFILE_FIELD_NAMES } from "../../../components/account/profile_input";
import { useProfileState } from "./hooks/use-profile-state";
export const ProfileDetailsWidget = () => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.userState);
    const [isEditing, setIsEditing] = useState("");
    const [isSaving, setIsSaving] = useState(false);
    const [name, setName] = useState(user.user?.name ?? "");
    const [surname, setSurname] = useState(user.user.surname ?? "");
    const [email, setEmail] = useState(user.user.email ?? "");
    const [phoneNumber, setPhoneNumber] = useState(user.user.cell_number ?? "");
    const [verificationComplete, setVerificationComplete] = useState(false);
    const [phoneNumberHasChanged, setPhoneNumberHasChanged] = useState(false);
    const { control, canSubmit, errors, register, submitForm, getValues } = useProfileState();
    useEffect(() => {
        dispatch(setContentModal(null));
        setPhoneNumberHasChanged(false);
    }, [verificationComplete]);
    const onSave = () => {
        if (canSubmit) {
            setIsSaving(true);
            const formValues = getValues();
            update_user_details({
                id: user.user._id ?? "",
                name: formValues.name,
                surname: formValues.surname,
                email: formValues.email,
                cell_number: formValues.phone_number,
            }).then((response) => {
                setIsSaving(false);
                if (response.success) {
                    dispatch(update_details_thunk({
                        name: formValues.name,
                        surname: formValues.surname,
                        email: formValues.email,
                        phoneNumber: formValues.phone_number,
                    }));
                    setIsEditing("");
                }
                else {
                    dispatch(setMainModal({ title: "Something went wrong!", messages: response.message }));
                }
            });
        }
    };
    return (React.createElement("div", { className: "flex flex-col gap-3 w-full" },
        React.createElement(ProfileInput, { name: PROFILE_FIELD_NAMES.name, value: name, label: "Full Name", setValue: setName, isEditing: isEditing, setIsEditing: setIsEditing, onSave: onSave, isSaving: isSaving, error: errors.name?.message?.toString() ?? "", control: control }),
        React.createElement(ProfileInput, { name: PROFILE_FIELD_NAMES.surname, value: surname, label: "Surname", setValue: setSurname, isEditing: isEditing, setIsEditing: setIsEditing, onSave: onSave, isSaving: isSaving, error: errors.surname?.message?.toString() ?? "", control: control }),
        React.createElement(ProfileInput, { name: PROFILE_FIELD_NAMES.email, value: email, label: "Email", setValue: setEmail, isEditing: isEditing, setIsEditing: setIsEditing, onSave: onSave, isSaving: isSaving, error: errors.email?.message?.toString() ?? "", control: control }),
        React.createElement(ProfileInput, { name: PROFILE_FIELD_NAMES.phone_number, value: phoneNumber, label: "Mobile Number", setValue: setPhoneNumber, isEditing: isEditing, setIsEditing: setIsEditing, onSave: onSave, isSaving: isSaving, verificationRequired: phoneNumberHasChanged, onVerificationComplete: () => setVerificationComplete(true), error: errors.phone_number?.message?.toString() ?? "", control: control })));
};
